export const customerName = (customer) => {
  if (customer.firstName || customer.lastName) {
    return `${customer.firstName} ${customer.lastName}`;
  }
  let name = '';
  if (customer.emails[0] && customer.emails[0].email) {
    name = `${customer.emails[0] && customer.emails[0].email}`;
  }
  return name;
};

export const showAdditionalFields = (fields, type) => {
  const allFields = fields.getAll();
  const last = allFields[fields.length - 1];
  if (!last || !last[type] || last[type] === '') {
    return false;
  }
  // should return boolean
  return true;
};
